<template>
  <div class="imageUpload">
    <div class="formImage__Wrapper">
      <div class="formImage__Input">
        <template v-if="item.thumbnail_urls && item.thumbnail_urls.card">
          <button type="button" @click="removeImage" class="formImage__InputRemove">
            <icon name="trash-alt"></icon>
          </button>

          <div class="formImage__InputPreview" :style="{ backgroundImage: `url(${item.thumbnail_urls.card})` }"></div>
        </template>

        <template v-else>
          <button type="button" @click="toggleModal(true)" class="formImage__InputUpload">
            <icon name="cloud-upload"></icon
            >{{ $store.getters.getStringTranslation(label.replace(/\s/g, '').toLowerCase()) }}
          </button>
        </template>
      </div>
    </div>

    <transition name="fade">
      <div class="modal--Uploads" v-if="visible">
        <button type="button" @click="toggleModal(false)" class="modal__Overlay">
          {{ $store.getters.getStringTranslation('close') }}
        </button>
        <uploads v-model="item" :selectable="true" :filterable="false" :defaults="{ types: ['image'] }" />
      </div>
    </transition>
  </div>
</template>

<script>
import Uploads from '@/components/Uploads.vue'

export default {
  props: {
    value: {
      type: [String, Object],
      default() {
        return {}
      },
    },
    label: {
      type: String,
      default: 'Set featured image',
    },
  },
  components: {
    Uploads,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    item: {
      set(val) {
        this.$emit('input', val.thumbnail_urls ? val.thumbnail_urls : val)
        if (val !== null) this.toggleModal(false)
      },
      get() {
        return {
          thumbnail_urls: this.value,
        }
      },
    },
  },
  methods: {
    toggleModal(val) {
      if (val === true) {
        this.$store.dispatch('setWrapperClass', 'no-Overflow')
      } else {
        this.$store.dispatch('setWrapperClass', null)
      }

      this.visible = val
    },
    removeImage() {
      this.item = ''
    },
  },
}
</script>
